<template>
    <transition
        @before-enter="appearAnimationBefore"
        @enter="appearAnimationEnter"
        @leave="appearAnimationLeave"
    >
        <div
            v-if="visible"
            @click="close"
            :class="buildClass"
            class="popup-message"
        >
            <div class="popup-message__window">
                <div class="popup-message__text">
                    <p v-html="text"></p>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import Velocity from 'velocity-animate'

export default {
    name: 'popup-message',
    props: {
        text: {
            type: String,
            default: '',
            required: true
        },
        type: {
            type: String,
            default: ''
        },
        state: {
            type: String,
            default: ''
        },
        show: Boolean
    },
    data () {
        return {
            visible: this.show
        }
    },
    mounted () {
        document.body.appendChild(this.$el)
    },
    watch: {
        show (value) {
            this.visible = value

            if (this.type === 'form' && value === true) this.timer()
        }
    },
    computed: {
        buildClass () {
            return {
                'popup-message--form': this.type === 'form',
                'popup-message--error': this.state === 'error',
                'popup-message--success': this.state === 'success'
            }
        }
    },
    methods: {
        close () {
            this.$emit('close')
        },
        timer () {
            setTimeout(() => this.close(), 5000)
        },
        appearAnimationBefore (el) {
            el.style.opacity = 0
        },
        appearAnimationEnter (el, done) {
            Velocity(el, { opacity: 1 }, { duration: this.duration }, { complete: done })
        },
        appearAnimationLeave (el, done) {
            Velocity(el, { opacity: 0 }, { duration: this.duration })
            Velocity(el, { display: 'none' }, { complete: done })
        }
    }
}
</script>

<style lang="scss">
    .popup-message {
        $parent: &;

        display: flex;
        align-items: center;
        flex-flow: row nowrap;
        justify-content: center;
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 10003;
        background-color: rgba(0,0,0,0.7);

        &__window {
            display: flex;
            align-items: center;
            flex-flow: row nowrap;
            justify-content: center;
            width: 35rem;
            height: 17rem;
            padding: 3rem 4rem;
            border-radius: .5rem;
            background-color: $token-colors-white;
        }

        &__text {
            line-height: 1;
            color: $token-colors-black-80;
            font-weight: 500;
            font-size: 1.5rem;
            font-family: FranklinGothic;

            p {
                margin: 0;

                &+& {
                    margin-top: 1rem;
                }
            }
        }

        &--form {

            #{$parent}__text {
                padding: .5rem 0 .5rem 1.5rem;
                border-left: .25rem solid $token-colors-black-10;
            }
        }

        &--error {

            #{$parent}__text {
                border-left-color: #E42213;
            }
        }

        &--success {

            #{$parent}__text {
                border-left-color: #009b19;
            }
        }
    }
</style>
